// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"16b55d64","23":"8a4e3a2d","116":"aa31ff80","160":"efc25258","190":"b84e878f","300":"2eb7823f","382":"89e38af5","661":"7a976342","784":"f30342d2","911":"4d6802ee"}[chunkId] + ".chunk.js";
};